import React from 'react';
var Api = require('./Config');
import _ from 'lodash';
import DASReport from './DASReport';
import { i18nText } from './i18nText';

import '../assets/scss/summary.scss';

export default class FaxSend2 extends React.Component {
  getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  constructor(props) {
    super(props);
    this.state = {
      doctor: {},
      p_ras: {},
      journey_ras: {},
      patient_ras: {},
      rows: [],
      patient_tcodes: [],
      containerStyle: { maxWidth: 800 },
      comments: [],
    };
  }

  componentWillReceiveProps(newProps) {
    var PMHID = _.get(this, 'props.match.params.PMHID', newProps.PMHID);
    var token = this.getParameterByName('token') || '';
    this.getData(PMHID, token, this.props.translated);
  }

  async getData(PMHID, token) {
    Api.getFaxContent(PMHID, token)
      .then((data) => {
        if (data.ERR) {
          window.status = 'DONE';
        }

        this.setState(data);

        if (token.length <= 0) {
          this.setState({ containerStyle: { width: 800 } });
        }
      })
      .catch((err) => {
        console.log(err);
        alert(err);
      });
  }

  componentDidMount() {
    var PMHID = _.get(this, 'props.match.params.PMHID', this.props.PMHID);
    var token = this.getParameterByName('token') || '';
    this.getData(PMHID, token, this.props.translated);
    /**
     * Liam's request for review portal
     */
    window.addEventListener('message', (event) => {
      if (event.data.action === 'print') {
        this.setState({ comments: event.data.comments });
        setTimeout(() => {
          window.print();
        }, 500);
      }
    });
  }

  getEncounterInfo(label, value) {
    return (
      <div className="encounter-info">
        <div className="encounter-label">{label}:</div>
        <div className="encounter-data">{value}</div>
      </div>
    );
  }

  getContent(patient_ref, rows, lang) {
    return (
      <div style={this.state.containerStyle} className="container container-fluid">
        <div className="title-container">
          <img className="logo" src={Api.getHost() + '/docportal_api/images/CMDr_logo.png'} />
          <span className="title">CAREMINDr Journey - Encounter Summary</span>
        </div>
        <hr style={{ width: '50%', border: 'thin solid #787878' }} />
        <div className="row encounter-row" style={{ marginBottom: 30 }}>
          <div className="col-xs-8">{this.getEncounterInfo('Office', this.state.doctor['title'])}</div>
          <div className="col-xs-4">{this.getEncounterInfo('App Code', this.state.doctor['app_code'])}</div>
        </div>
        <div className="row encounter-row">
          <div className="col-xs-4">{this.getEncounterInfo('Pt#', this.state.p_ras['patient_ref'])}</div>
          <div className="col-xs-2">{this.getEncounterInfo('Birth', this.state.p_ras['yob'])}</div>
          <div className="col-xs-3">{this.getEncounterInfo('Gender', this.state.p_ras['gender'])}</div>
          <div className="col-xs-3">{this.getEncounterInfo('T-Code', this.state.t_code)}</div>
        </div>
        <div className="row encounter-row">
          <div className="col-sm-12">{this.getEncounterInfo('Journey', this.state.journey_ras['journey_name'])}</div>
        </div>
        {/* Guardrails */}
        {this.state.has_guard_rail == 'yes' && (
          <div className="row">
            <div className="col-sm-12 guardrails-container">
              <table className="table borderless" style={{ width: '85%', margin: '10px auto 20px auto' }}>
                <tbody>
                  <tr>
                    {this.state.journey_ras.show_emergency_alert == 'Y' && (
                      <td>
                        Low <br /> Emerg
                      </td>
                    )}
                    <td>
                      Low <br /> Crit
                    </td>
                    <td>
                      Low <br /> Warn
                    </td>
                    {this.state.guard_rail.high_warning && (
                      <td>
                        High <br /> Warn
                      </td>
                    )}
                    {this.state.guard_rail.high_alert && (
                      <td>
                        High <br /> Crit
                      </td>
                    )}
                    {this.state.journey_ras.show_emergency_alert == 'Y' && (
                      <td>
                        High <br /> Emerg
                      </td>
                    )}
                  </tr>
                  <tr className="primary-data">
                    {this.state.journey_ras.show_emergency_alert == 'Y' && (
                      <td>{this.state.guard_rail.low_emergency}</td>
                    )}
                    <td>{this.state.guard_rail.low_alert}</td>
                    <td>{this.state.guard_rail.low_warning}</td>
                    {this.state.guard_rail.high_warning && <td>{this.state.guard_rail.high_warning}</td>}
                    {this.state.guard_rail.high_alert && <td>{this.state.guard_rail.high_alert}</td>}
                    {this.state.journey_ras.show_emergency_alert == 'Y' && (
                      <td>{this.state.guard_rail.high_emergency}</td>
                    )}
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
        <hr style={{ width: '85%' }} />
        {this.state.patient_ras.inactive_type && (
          <div className="row encounter-row inactive-details">
            <h1>
              {this.state.patient_ras.inactive_type === 'NO_ACTIVITY'
                ? i18nText('noActivityAlert', lang)
                : i18nText('noStartAlert', lang)}
            </h1>
            <p
              dangerouslySetInnerHTML={{
                __html: i18nText('noActivityDesc', lang, [this.state.patient_ras.inactive_days]),
              }}
            ></p>
            {this.state.patient_tcodes.length > 0 && (
              <div className="text-left" style={{ marginTop: 20, marginBottom: 40 }}>
                <p>{i18nText('otherTcodeDesc', lang)}</p>
                {this.state.patient_tcodes.map((item) => {
                  return (
                    <b>
                      {item.t_code} - {item.journey_name}
                      <br></br>
                    </b>
                  );
                })}
              </div>
            )}
            {rows.length > 0 && <p>Last response sent in by patient:</p>}
            <hr style={{ marginBottom: 0 }} />
          </div>
        )}
        {this.state.SHW != null && (
          <div>
            <b>SHW Status</b>
            {
              <div style={{ borderWidth: 1, borderStyle: 'solid', width: '100%', height: 75, padding: 5 }}>
                {this.state.SHW != 'NO_DATA' && <div>{this.state.SHW_MESSAGE}</div>}
                {this.state.SHW == 'NO_DATA' && <div>You don't have any course.</div>}
                {this.state.shw_alert != '' && <div>Alert: {this.state.shw_alert}</div>}
              </div>
            }
            <hr style={{ marginBottom: 0 }} />
          </div>
        )}
        {rows.length > 0 && (
          <React.Fragment>
            <div className="row encounter-row" style={{ marginTop: 30 }}>
              <div className="primary-data text-center">
                SENT-IN BY USER ON: {Api.getDateFormat(this.state.patient_ras.last_response_date)}{' '}
                {Api.getTimeZoneName()}
              </div>
            </div>
            <table className="table ">
              <tbody>
                {_.map(rows, (single, index) => {
                  if (single.type == 'TEXT_TYPE') {
                    return null;
                  }
                  const ans = Api.getAnswerFormated(single.answer);
                  let anwerhtml = ans[0];
                  if (ans[1] == true) {
                    anwerhtml = "<img height='40' width='40' src='" + ans[0] + "'/>";
                  }

                  if (['DATE', 'APPTDATE', 'ALREADYHADAPPTDATE'].includes(single.type)) {
                    const dateParts = anwerhtml.split('-');
                    const monthName = Api.getMonthName(dateParts[1]);
                    anwerhtml = `${monthName} ${dateParts[2]}, ${dateParts[0]}`;
                  }

                  return (
                    <tr>
                      <td>{single.question}</td>
                      <td style={{ width: 150, textAlign: 'right' }}>
                        <span dangerouslySetInnerHTML={{ __html: anwerhtml }}></span>
                      </td>
                      <td style={{ width: 55 }}>
                        {single.icon && (
                          <div style={{ width: 30, height: 30 }}>
                            <img
                              style={{ width: '100%', height: '100%' }}
                              src={Api.getHost() + 'docportal_api/' + single.icon}
                            />
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </React.Fragment>
        )}
        <div className="encounter-row">
          <DASReport
            category={this.state.journey_ras.category}
            patient_ref={patient_ref}
            faxMode={true}
            sentInDate={this.state.patient_ras.acknowledged_on}
            currentTcode={this.state.t_code}
          />
        </div>
        <div className="footer-info text-center" style={{ width: '100%' }}>
          Questions or Problems: Email: info@CAREMINDr.com / Fax: 408.716.0339 / Text: 408.909.4231
        </div>
      </div>
    );
  }

  getComments() {
    if (this.state.comments.length <= 0) {
      return;
    }

    const cellPadding = { padding: '5px' };

    return (
      <>
        <div style={{ pageBreakAfter: 'always' }}></div>
        <table className="table-bordered table-striped" style={{ width: '100%' }}>
          <tr>
            <th style={cellPadding}>Date</th>
            <th style={cellPadding}>Comment</th>
            <th style={cellPadding}>Author</th>
          </tr>
          {this.state.comments.map((comment) => (
            <tr>
              <td style={cellPadding}>{comment.date}</td>
              <td style={cellPadding}>{comment.text}</td>
              <td style={cellPadding}>{comment.author}</td>
            </tr>
          ))}
        </table>
      </>
    );
  }

  render() {
    let patient_ref = '';
    if (this.state.p_ras['patient_ref'] == null) {
      return <div></div>;
    } else {
      const patientParts = Api.getPatientRefParts(this.state.p_ras['patient_ref']);
      patient_ref = patientParts.mrn + patientParts.patientInitials;
    }

    return (
      <div className="encounter-summary">
        {this.getContent(patient_ref, this.state.rows.original, this.state.journey_ras.lang)}
        {this.state.rows.translated && (
          <div style={{ marginTop: 50 }}>
            <div style={{ pageBreakAfter: 'always' }}></div>
            {this.getContent(patient_ref, this.state.rows.translated, 'en')}
          </div>
        )}
        {this.getComments()}
      </div>
    );
  }
}
